import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from 'Components/Shared/Modal/ConfirmationModal';
import { strings } from 'Constants/Export/Strings';
import { commonStrings } from 'Constants/CommonStrings';

class DeleteExportFileModal extends React.PureComponent {
  render() {
    const {
      onConfirm, onCancel, isModalOpen,
    } = this.props;

    return (
      <ConfirmationModal
        open={isModalOpen}
        title={strings.exportDeleteTitle}
        message={strings.exportDeleteNote}
        acceptText={commonStrings.delete}
        onConfirm={() => onConfirm()}
        onCancel={() => onCancel()}
      />
    );
  }
}

DeleteExportFileModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
};

export default (DeleteExportFileModal);
